import Checkbox from "@mui/material/Checkbox";
import Typography from "@mui/material/Typography";
import { FC, SyntheticEvent } from "react";
import AutocompleteField from "shared/components/Form/AutocompleteField";
import TextField from "shared/components/Form/TextField";
import FieldLabel from "shared/components/Form/components/FieldLabel";
import { COLOR_BLACK, COLOR_GREY_9 } from "shared/theme/colors";
import { CheckBoxIcon } from "shared/theme/icons/CheckBoxIcon";
import { CheckedBoxIcon } from "shared/theme/icons/CheckedBoxIcon";
import { type TagOption } from "widgets/ModuleTagsWidget/type";

type Props = {
  value: TagOption[];
  options: TagOption[];
  onChange: (value: TagOption[]) => void;
  loading: boolean;
  placeholder: string;
  disabled?: boolean;
  label?: string;
};

const TagsAutocomplete: FC<Props> = (props) => {
  const handleChange = (_: SyntheticEvent, value: TagOption[]) => {
    props.onChange(value);
  };

  return (
    <AutocompleteField
      multiple
      disableCloseOnSelect
      value={props.value}
      options={props.options}
      onChange={handleChange}
      disabled={props.disabled}
      loading={props.loading}
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, value) =>
        option?.id?.toString() === value?.id?.toString()
      }
      renderOption={(props, option, { selected }) => {
        return (
          <li {...props} key={props.key}>
            <Checkbox
              icon={<CheckBoxIcon />}
              checkedIcon={<CheckedBoxIcon />}
              style={{ marginRight: 8 }}
              checked={selected}
              id={props.id}
            />
            <Typography color={COLOR_BLACK} variant="bodyMRegular">
              {option.name}
            </Typography>
          </li>
        );
      }}
      renderInput={(params) => (
        <>
          <FieldLabel
            label={props.label}
            labelColor={props.disabled ? COLOR_GREY_9 : COLOR_BLACK}
          />
          <TextField
            {...params}
            placeholder={props.placeholder}
            sx={{
              "& .MuiOutlinedInput-root": {
                "&.Mui-disabled": {
                  "& .MuiOutlinedInput-input": {
                    cursor: "not-allowed",
                    background: "none !important",
                  },
                },
              },
            }}
          />
        </>
      )}
    />
  );
};

export default TagsAutocomplete;
